<template>
  <div id="thermal">
    <div class="page" size="A4" v-for="page in pages" :key="'page' + page">
      <v-row class="pt-4 justify-center">
        <v-col class="text-center" cols="2">
          <v-avatar size="45">
            <img
              src="https://casasdastintas.com.br/_nuxt/icons/icon_512x512.9bcf77.png"
            />
          </v-avatar>
        </v-col>
        <v-col style="line-height: 12pt">
          <b style="font-size: 10px">Rede Casas das Tintas</b>
          <template v-if="hasAddress">
            <div>
              {{ company.main_address.address }}
              {{ company.main_address.number }},
              {{ company.main_address.district }}
            </div>
            <div>
              {{ company.main_address.city }} -
              {{ company.main_address.state }},
              {{ $format.cep(company.main_address.postal_code) }},
            </div>
          </template>
          <div v-if="hasPhones" class="d-flex flex-row">
            <span class="mr-2">Tel:</span>
            <div v-for="(phone, index) in company.phones" :key="index">
              {{ phone.contact }}

              <span class="mr-1" v-if="company.phones.length > index + 1"
                >,</span
              >
            </div>
          </div>
        </v-col>
      </v-row>

      <hr class="my-4" />
      <v-row class="text-center my-2">
        <v-col><h2>Recibo de Pagamento</h2> </v-col>
      </v-row>

      <v-row>
        <v-col>
          Recebemos de
          <b>
            {{ bill_receivable_group.customer.code }} -
            {{ bill_receivable_group.customer.name }}
          </b>
          a Importância de
          {{ $format.decimal(bill_receivable_group.net_paid_value) }}
          <b> ({{ $format.extenso(bill_receivable_group.net_paid_value) }}) </b>
          Referente Ao Pagamento das Seguintes Prestações:
        </v-col>
      </v-row>
      <v-row class="mt-5">
        <v-col>
          <v-data-table
            :page="page"
            :headers="headers"
            :items="getItems(page)"
            :items-per-page='-1'
            hide-default-footer
            disable-sort
            dense
          >
            <template v-slot:[`item.document`]="{ item }">
              {{ item.bill_receivable.document }}
            </template>
            <template v-slot:[`item.issue_date`]="{ item }">
              {{ $format.dateBr(item.bill_receivable.issue_date) }}
            </template>
            <template v-slot:[`item.due_date`]="{ item }">
              {{ $format.dateBr(item.bill_receivable.due_date) }}
            </template>
            <template v-slot:[`item.value`]="{ item }">
              <span v-if="item.id">
                {{ $format.decimal(item.bill_receivable.value) }}
              </span>
            </template>
          </v-data-table>
        </v-col>

        <v-col
          style="font-size: 10px"
          class="d-flex flex-column text-right"
          cols="12"
        >
          <b>
            Valor Pago:
            {{ $format.moneyBr(bill_receivable_group.net_paid_value) }}
          </b>
        </v-col>
      </v-row>
      <v-row class="mt-10 text-center">
        <v-col cols="12">
          Para maior clareza firmamos o presente.
          <br />
          {{ company.main_address.city }}-{{ company.main_address.state }},
          {{ $format.dateBr(bill_receivable_group.paid_at) }}
        </v-col>

        <v-col cols="12" class="py-10">
          <v-divider style="border: 0.1px solid black; font-weight: bold" />
          Assinatura
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import format from "date-fns/format";

export default {
  props: {
    bill_receivable_group: {
      type: Object,
    },
    company: {
      type: Object,
    },
    hasAddress: {},
    hasPhones: {},
  },

  data() {
    return {
      date: format(new Date(), "dd/MM/yyyy"),
      headers: [
        { text: "Doc", align: "center", value: "document" },
        { text: "Emis", align: "center", value: "issue_date" },
        { text: "Ven", align: "center", value: "due_date" },
        {
          text: "V. Original",
          align: "center",
          value: "value",
        },
      ],
    };
  },

  computed: {
    pages() {
      return Math.ceil(this.itensCount / this.itensPerPage);
    },

    bill_receivable_payment() {
      return this.bill_receivable_group.bill_receivable_payment;
    },
    itensCount() {
      if (this.bill_receivable_payment) {
        return this.bill_receivable_payment.length;
      }
      return 1;
    },
    itensPerPage() {
      if (this.bill_receivable_payment) {
        return this.bill_receivable_payment.length;
      }
      return 1;
    },
  },

  methods: {
    saleNumber(bill_receivable) {
      return bill_receivable.sale ? bill_receivable.sale.number : "----";
    },

    getBillReceivable(item) {
      if (item.bill_receivable) {
        console.log(item);
        return item.bill_receivable.value;
      }
    },

    getItems(page) {
      let items = this.bill_receivable_payment.slice(
        (page - 1) * this.itensPerPage,
        page * this.itensPerPage
      );
      if (items.length < this.itensPerPage) {
        for (let i = items.length; i < this.itensPerPage; i++) {
          items.push({
            bill_receivable: {},
          });
        }
      }
      return items;
    },
  },
};
</script>


<style  lang="scss"  >
@import "@/assets/style/prints/ThermalPrinting.scss";
</style>

